import { TheNightlySection } from '@news-mono/common'
import { Topic, AdTargeting } from '@news-mono/web-common'
import { layout } from '../../../App.routing'
import { cardList } from '../../home/get-cardList-segment'

export const getSubTopicComposition = ({
    section,
    topic,
    adTargeting,
    contextId,
    isCommonwealthGamesMedalWidgetEnabled,
}: {
    section: Exclude<TheNightlySection, 'default'>
    topic: Topic
    adTargeting: AdTargeting
    contextId: string
    isCommonwealthGamesMedalWidgetEnabled?: boolean
}) => {
    return [
        layout.nestedComposition({
            type: 'luna',
            props: {
                dividerConfig: {
                    column: {
                        hasAsideAndAfterAsideDivider: false,
                    },
                },
            },
            contentAreas: {
                // Main content
                beforeAside: [
                    layout.component({
                        type: 'topic-section-card-list',
                        props: {
                            dataDefinitionArgs: {
                                type: 'context',
                                contextId,
                                section: section,
                            },
                            expectedItemCount: 15,
                            adUnits: 3,
                            adTargeting,
                        },
                    }),
                ],
                // sidebar small cards
                aside: [
                    layout.nestedComposition({
                        type: 'box',
                        props: {
                            stickyOffset:
                                'calc(var(--stickyHeaderHeight) + 80px)',
                        },
                        contentAreas: {
                            main: [
                                ...(isCommonwealthGamesMedalWidgetEnabled
                                    ? [
                                        layout.component(
                                            {
                                                type: 'commonwealth-games-medal-tally-widget',
                                                props: {
                                                    maxRows: 10,
                                                    refreshIntervalSeconds: 60,
                                                    sortable:
                                                        false,
                                                    size: 'small',
                                                    widgetState: 'results',
                                                    includeTotal: true
                                                },
                                            },
                                        ),
                                        layout.component({
                                            type: 'general-horizontal-divider',
                                            props: {
                                                verticalSpacing: 'outerMargin',
                                            },
                                        }),
                                    ]
                                    : []),
                                cardList({
                                    data: {
                                        type: 'context',
                                        contextId,
                                        section: section,
                                    },
                                    heading: 'Latest',
                                    numbered: false,
                                    hideMedia: true,
                                    adNoticePosition: 'above-center',
                                    headerColorOverride: 'inherit',
                                    startIndex: 15,
                                }),
                                layout.component({
                                    type: 'ad-unit',
                                    props: {
                                        adType: 'inline',
                                        noticePosition: 'above-center',
                                        slot: {
                                            id: 'sidebar',
                                            size: 'above1280MrecLeaderboardAbove768MrecBelow',
                                        },
                                    },
                                }),
                            ],
                        },
                    }),
                ],
                afterAside: [],
            },
        }),
        // pagination
        layout.component({
            type: 'pagination',
            props: { contextId },
        }),
    ]
}
